export default {
  FETCH_NEWSLETTERS_REQUEST: 'FETCH_NEWSLETTERS_REQUEST',
  FETCH_NEWSLETTERS_SUCCESS: 'FETCH_NEWSLETTERS_SUCCESS',
  FETCH_NEWSLETTERS_FAILURE: 'FETCH_NEWSLETTERS_FAILURE',
  UPDATE_NEWSLETTERS_QUERY: 'UPDATE_NEWSLETTERS_QUERY',
  UPDATE_NEWSLETTERS_FILTERS: 'UPDATE_NEWSLETTERS_FILTERS',
  RESET_NEWSLETTERS: 'RESET_NEWSLETTERS',
  RESET_FILTERS: 'RESET_FILTERS'
}
